<template>
    <div>
        <div class="layout">
            <div class="layout__header">
                <div class="layout__title">
                    <h3>Comprobante electrónico</h3>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <div class="card">
                    <div class="card__title">
                        <h5>Información del comprobante</h5>
                    </div>
                    <div class="card__content">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="table-responsive">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td><strong>Tipo de comprobante</strong></td>
                                                <td>{{ comprobante.tipo_comprobante.descripcion }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Número de documento</strong></td>
                                                <td>{{ comprobante.numero_documento }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Fecha de emisión</strong></td>
                                                <td>{{ comprobante.fecha_emision_comprobante }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Tipo de emisión</strong></td>
                                                <td>{{ comprobante.tipo_emision.descripcion }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Clave de acceso</strong></td>
                                                <td>{{ comprobante.clave_acceso }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Fecha de autorización</strong></td>
                                                <td>{{ comprobante.fecha_autorizacion_comprobante }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Número de autorización</strong></td>
                                                <td>{{ comprobante.numero_autorizacion }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Cliente</strong></td>
                                                <td>{{ comprobante.nombre_cliente }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Número de identificación</strong></td>
                                                <td>{{ comprobante.numero_identificacion }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Correo del cliente</strong></td>
                                                <td>{{ comprobante.correo_cliente }}</td>
                                            </tr>
                                            <tr v-show="comprobante.valor_total !== null">
                                                <td><strong>Total del comprobante</strong></td>
                                                <td>$ {{ parseFloat(comprobante.valor_total).toLocaleString(locale) }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Estado del comprobante</strong></td>
                                                <td>{{ (comprobante.estado_comprobante !== null?comprobante.estado_comprobante.descripcion:'Emitido') }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div v-show="comprobante.id_estado_comprobante === 'AUT' && comprobante.intento_correo" class="row center-xs">
                            <div class="col-xs-12">
                                <button @click="enviarCorreo" type="button" class="btn-info">
                                    <i class="fa fa-envelope-o"></i> <span>Re-enviar correo electrónico</span>
                                </button>
                                 <a target="_blank" :href="url + '/comprobantes?tipo_comprobante=' + comprobante.id_tipo_comprobante + '&id_comprobante=' + comprobante.id_comprobante" class="btn-success"><i class="fa fa-edit"></i> <span>Ver comprobante</span></a>
                            </div>
                        </div>
                        <div class="row center-xs">
                            <div class="col-xs-12">
                                <a target="_blank" v-show="comprobante.path_generado !== null" class="btn-info btn--text" :href="url + '/xml/' + comprobante.id_comprobante + '/generado'"><i class="fa fa-file-excel-o"></i><span>XML Generado</span></a>
                                <a target="_blank" v-show="comprobante.path_firmado !== null" class="btn-secondary btn--text" :href="url + '/xml/' + comprobante.id_comprobante + '/firmado'"><i class="fa fa-file-excel-o"></i><span>XML Firmado</span></a>
                                <a target="_blank" v-show="comprobante.path_rechazado !== null" class="btn-danger btn--text" :href="url + '/xml/' + comprobante.id_comprobante + '/rechazado'"><i class="fa fa-file-excel-o"></i><span>XML Rechazado</span></a>
                                <a target="_blank" v-show="comprobante.path_enviado !== null" class="btn-primary btn--text" :href="url + '/xml/' + comprobante.id_comprobante + '/enviado'"><i class="fa fa-file-excel-o"></i><span>XML Enviado</span></a>
                                <a target="_blank" v-show="comprobante.path_no_autorizado !== null" class="btn-warning btn--text" :href="url + '/xml/' + comprobante.id_comprobante + '/no-autorizado'"><i class="fa fa-file-excel-o"></i><span>XML No Autorizado</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12">
                <br>
                <div class="card">
                    <div class="card__title">
                        <h5>Logs</h5>
                    </div>
                    <div class="card__content">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="table-responsive">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Tipo de ambiente</th>
                                                <th>Fecha</th>
                                                <th>Respuesta</th>
                                                <th>Tipo de evento</th>
                                                <th>Información adicional</th>
                                                <th>Identificador</th>
                                                <th>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-show="comprobante.respuestas.length === 0">
                                                <td colspan="7">
                                                    <strong>No se encontró eventos.</strong>
                                                </td>
                                            </tr>
                                            <tr :key="index" v-for="(evento, index) in comprobante.respuestas">
                                                <td>{{ evento.tipo_ambiente !== null?evento.tipo_ambiente.descripcion:'-' }}</td>
                                                <td>{{ evento.fecha }}</td>
                                                <td>{{ evento.respuesta }}</td>
                                                <td>{{ evento.tipo }}</td>
                                                <td>{{ evento.informacion_adicional }}</td>
                                                <td>{{ evento.identificador }}</td>
                                                <td>{{ evento.estado }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        comprobante : {
            type : Object,
            required : true
        }   
    },
    data : function () {
        return {
            locale : locale,
            url : url
        }
    },
    methods : {
        enviarCorreo : function () {
            let that = this;
            axios.post(this.url + '/comprobantes/' + this.comprobante.id_comprobante + '/correo').then(function (response) {
                let comprobantesAfectados = response.data.comprobantesAfectados;
                if (comprobantesAfectados > 0)
                    swal('El comprobante ha sido enviado a la cola de envío de correos electrónicos.', 'Aviso', 'success');
                else 
                    swal('No se ha enviado el correo electrónico.', 'Aviso', 'warning');
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/Logs.vue